import { ReportByViewExpense } from "@common/utils/graphql";
import { useState } from "react";

export const useRowActions = (expenses: ReportByViewExpense[]) => {
  const [approvedIds, setApprovedIds] = useState<number[]>([]);
  const [rejectedIds, setRejectedIds] = useState<number[]>([]);

  const applyRows = (approved: boolean, id: number) => {
    const approvedSet = new Set(approvedIds);
    const rejectedSet = new Set(rejectedIds);
    if (approved) {
      approvedSet.add(id);
      rejectedSet.delete(id);
    } else {
      rejectedSet.add(id);
      approvedSet.delete(id);
    }
    setApprovedIds([...approvedSet]);
    setRejectedIds([...rejectedSet]);
  };

  const applyAllRows = (approved: boolean) => {
    const allIds = expenses.map((exp) => exp.id);
    if (approved) {
      setApprovedIds(allIds);
      setRejectedIds([]);
    } else {
      setRejectedIds(allIds);
      setApprovedIds([]);
    }
  };

  return {
    applyRows,
    applyAllRows,
    approvedIds,
    rejectedIds,
  };
};
